import { getNews as getNewsM } from "../../mock/home/MockNews";

export const getNews = async () => {
    return await getNewsM();

    //use API
};